(function($) {

     $(document).on('click', '.technology-list li a.hide-on-mobile', function(){

          $('.technology-list li a.hide-on-mobile').removeClass('active');
          $(this).addClass('active');
          
     });

     $(document).on('click', '.office-list li', function(){
          if( !$(this).hasClass('active') ){
               $('.office-list li').removeClass('active');
               $(this).addClass('active');
               $('.office-list li .addressinfo').slideUp('fast');
               $(this).find('.addressinfo').slideDown('fast');
          }

     });

     $(document).on('click', 'a#searchlink', function(){
          if(!$('div.searchcontainer').hasClass('active')){
               $('div.searchcontainer').addClass('active');
               $('div.searchcontainer').fadeIn('fast');
          }else{
               $('div.searchcontainer').removeClass('active');
               $('div.searchcontainer').fadeOut('fast');
          }
     });

     $(document).on('mouseenter', 'a.herolink', function(){
          var slideNumber = $(this).attr('data-index');
          $('.slide-content header').hide();
          $('.slide-content header[data-index='+slideNumber+']').fadeIn('fast');
          $('.sliderbackground').each(function(idx){
               if(idx > slideNumber){
                    $(this).hide();
               }
          });
          $('.sliderbackground[data-index='+slideNumber+']').fadeIn('fast');
     });

     $(document).on('click', '.technology-list a', function(){
          var cardNumber = $(this).attr('data-service-id');
          $('.technology-card').hide();
          $('.technology-card[data-service-id='+cardNumber+']').fadeIn('fast');
     });

     $(document).on('click', 'a#closesearch', function(){
          $('div.searchcontainer').fadeOut('fast');
     });

     $(document).mouseup(function(e) {
          var container = $('div.searchcontainer');
          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0){
               container.fadeOut('fast');
          }
     });

     $(document).ready(function(){
          $('body').addClass('ready');
     });

     $('.mobile-hero-slider-nav .dots li').click(function(){
          $('.active').removeClass('active');
          $(this).addClass('active');

          var slideNumber = $(this).find( "a" ).attr('data-index');
          $('.slide-content header').hide();
          $('.slide-content header[data-index='+slideNumber+']').fadeIn('fast');
          $('.sliderbackground').each(function(idx){
               if(idx > slideNumber){
                    $(this).hide();
               }
          });
          $('.sliderbackground[data-index='+slideNumber+']').fadeIn('fast');
     });

     $(document).on('click', '.loadmore',function(){
          if(!ajax_post_params){
               return;
          }

		var button = $(this),
		data = {
			'action': 'loadmore',
			'query': ajax_post_params.posts, // that's how we get params from wp_localize_script() function
			'currentpage' : ajax_post_params.current_page,
               'tax' : ajax_post_params.tax
		};

		$.ajax({ // you can also use $.post here
			url : ajax_params.ajaxurl, // AJAX handler - this comes from our localized while the other comes from on page script
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) {
					console.log( data );
                         button.text('Load More');
                         $('.postgrid').append(data);
                         Foundation.reInit('equalizer');
					ajax_post_params.current_page++;

					if ( ajax_post_params.current_page == ajax_post_params.max_page )
						button.remove(); // if last page, remove the button

					// you can also fire the "post-load" event here if you use a plugin that requires it
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	});

     $(document).on('change','#categoryselector', function(){
          var button = $('.loadmore');
          var newscat = $(this).find('option:selected').attr('value');
          ajax_post_params.tax = newscat;
          ajax_post_params.current_page = 0;
          ajax_post_params.paged = 0;
          //alert( ajax_post_params.tax );
          //alert( ajax_post_params.current_page );
          data = {
			'action': 'loadmore',
			'query': ajax_post_params.posts, // that's how we get params from wp_localize_script() function
			'currentpage' : ajax_post_params.current_page,
               'tax' : ajax_post_params.tax
		};

		$.ajax({ // you can also use $.post here
			url : ajax_params.ajaxurl, // AJAX handler - this comes from our localized while the other comes from on page script
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) {
					//button.text( 'Load More' ).prev().before(data); // insert new posts
                         button.text('Load More');
                         $('.postgrid').empty().append(data);
                         Foundation.reInit('equalizer');
					ajax_post_params.current_page++;

					if ( newscat !== 'all' ){
                              button.remove(); // if last page, remove the button
                         }else{
                              $('.loadmore-container .grid-x .cell').append('<a class="loadmore button">Load More</a>');
                         }
					// you can also fire the "post-load" event here if you use a plugin that requires it
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});

     });

     $("#search").on("keyup", function() {
          var value = $(this).val().toLowerCase();
          $(".professionals-grid .personcell").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
          });
        });

     $(document).on('click', 'span.lettersort', function(e){
          if($('span.lettersort').hasClass('active')) {
               $('span.lettersort').removeClass('active');
          }
          $(this).addClass('active');
          var letter = $(this).data('letter');
          $('.personcell').show();
          $('.personcell').each(function(idx){
               if($(this).data('letter')!==letter){
                    $(this).hide();
               }
          });
          $('select#pa, select#region').val('default');

     });
     $(document).on('click', 'span.showall', function(e){
          $('.personcell').show();
          $('select#pa, select#region').val('default');
     });

     $(document).on('change', 'select#pa', function(e){
          if($('span.lettersort').hasClass('active')) {
               $('span.lettersort').removeClass('active');
          }
          var current = $("option:selected", this).val();
          if( current == 'default'){
               $('.personcell').show();
               
          }else{
               $('.personcell').each(function(idx){
                    var personarray = $(this).data('practice-areas');
                    if( !personarray.includes(current) ){
                         $(this).hide();
                    }else{
                         $(this).show();
                    }
               });
          }
     });
     $(document).on('change', 'select#region', function(e){
          if($('span.lettersort').hasClass('active')) {
               $('span.lettersort').removeClass('active');
          }
          var current = $("option:selected", this).val();
          if( current == 'default'){
               $('.personcell').show();
          }else{
               $('.personcell').each(function(idx){
                    var region = $(this).data('region');
                    if( !region.includes(current) ){
                         $(this).hide();
                    }else{
                         $(this).show();
                    }
               });
          }
     });

     window.onload = function(e){
          if( $('section.people.leadership').length ){
               $('section.people.leadership').each(function(idx){
                    var leftheight = $(this).find('.leadershipintro').height();
                    var finalheight = leftheight + 120;
                    $(this).find('.dynamicbg').animate({
                         height: finalheight
                    }, 300, function(){
                         //
                    });
                    $(this).find('.dummysquare').animate({
                         height: leftheight
                    }, 300, function(){
                         //
                    });
               });
          }
     }


})( jQuery );
